/**
 * @desc 新增采购调价申请单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ProcurementOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/saveProcurementOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
